<script setup lang="ts">
  import { OverlayDrawer } from '@/shared/ui/components'

  import { useProfile } from '@/entities/profile'

  import { TableContent, TableHeader, TransactionDetails, useTransactionsView } from '@/views/transactions'

  definePage({
    meta: {
      layout: 'baseNew',
    },
  })

  const { t } = useI18n()

  useHead({
    title: () => t('navigation_item_transactions'),
  })

  const { isAdmin } = storeToRefs(useProfile())

  const {
    isLoading,
    transactionList,
    filterQuery,
    page,
    recordsPerPage,
    sortState,
    totalPages,
    dateFormat,
    dateRange,
    selectedUserIds,
    transactionType,
    isDetailsLoading,
    transactionDetails,
    showTransactionDetails,
    handleSortUpdate,
    onTablePageChanged,
    onPageSizeChanged,
    onTableRowClick,
  } = useTransactionsView()
</script>

<template>
  <OverlayDrawer
    v-model="showTransactionDetails"
    fullscreen
    placement="right"
    drawer-width="423px"
    data-testid="transactions-details-drawer"
  >
    <div class="wide-responsive relative flex h-full flex-col overflow-hidden">
      <div class="border-border border-b">
        <div class="relative flex flex-col gap-4 p-6 pt-8 pb-6">
          <h1 class="heading-md text-heading! m-0">
            {{ $t('navigation_item_transactions') }}
          </h1>

          <TableHeader
            v-model:date-range="dateRange"
            v-model:selected-user-ids="selectedUserIds"
            :show-user-select="isAdmin"
            :date-format="dateFormat"
            :filter-query="filterQuery"
          />
        </div>
      </div>

      <div class="wide-responsive flex-1 px-6 py-4">
        <TableContent
          v-model:transaction-type="transactionType"
          :page="page"
          :page-size="recordsPerPage"
          :sort-state="sortState"
          :is-loading="isLoading"
          :rows="transactionList || []"
          :total-pages="totalPages"
          @row-click="onTableRowClick"
          @sort-change="handleSortUpdate"
          @page-changed="onTablePageChanged"
          @page-size-changed="onPageSizeChanged"
        />
      </div>
    </div>

    <template #drawer>
      <TransactionDetails
        :is-loading="isDetailsLoading"
        :data="transactionDetails"
        @close="showTransactionDetails = false"
      />
    </template>
  </OverlayDrawer>
</template>
